// Region-specific display text for form fields, keyed by regionId (see regionTimezoneMapping
// in StaticData.jsx: 1 = Netherlands, 2 = Spain, 3 = Luxembourg).
// To add another field whose label/text varies by region, add a key to REGION_LABELS
// below and export a small getter for it, following the getTaxIdLabel pattern.
const REGION_LABELS = {
  taxId: { 1: 'KvK', 2: 'N.I.F', 3: 'RCS' },
};

const getRegionLabel = (field, regionId, fallback) =>
  REGION_LABELS[field]?.[regionId] || fallback;

// Tax ID field label per region (RAT-1822): Netherlands -> KvK, Spain -> N.I.F, Luxembourg -> RCS.
export const getTaxIdLabel = (regionId) =>
  getRegionLabel('taxId', regionId, 'Tax ID');

// Kept for the Organization/Seller invoice PDF's Tax ID label, which is
// derived from the account's own country rather than an operating region
// (matches the backend's getTaxIdLabelForCountry in commonFormat.util.ts).
// The edit/view forms use getTaxIdLabel(regionId) below instead, now that
// Seller/Organization have a real Region field (RAT-1861).
const TAX_ID_LABEL_BY_COUNTRY_NAME = {
  NETHERLANDS: 'KvK',
  'THE NETHERLANDS': 'KvK',
  NEDERLAND: 'KvK',
  SPAIN: 'N.I.F',
  ESPAÑA: 'N.I.F',
  LUXEMBOURG: 'RCS',
};

export const getTaxIdLabelForCountry = (country) =>
  TAX_ID_LABEL_BY_COUNTRY_NAME[(country || '').trim().toUpperCase()] ||
  'Tax ID';

// RAT-1788/RAT-1861: native language to render the bilingual Country/Province
// dropdown labels in, based on the account's operating region. Shared by
// MerchantAddEdit and AdminUserAddEdit so Organization/Seller get the same
// "Local name (English name)" treatment Merchant already has.
const REGION_LOCALE_MATCHES = [
  ['spain', 'es'],
  ['españa', 'es'],
  ['netherlands', 'nl'],
  ['nederland', 'nl'],
  ['luxembourg', 'fr'],
  ['germany', 'de'],
  ['deutschland', 'de'],
  ['france', 'fr'],
  ['belgium', 'nl'],
  ['italy', 'it'],
  ['portugal', 'pt'],
];

export const localeForRegion = (regionLabel) => {
  const label = (regionLabel || '').toLowerCase();
  const hit = REGION_LOCALE_MATCHES.find(([key]) => label.includes(key));
  return hit ? hit[1] : 'en';
};
